export class Rounder {
  public static RoundCurrency(input: number): number {
    return (Math.round(input * 100) / 100);
  }
}